import { SafeUrl } from '@angular/platform-browser';
import { ImageTypes } from '../../enums/image-types';
import { ImageUploadStatus } from '../../enums/image-upload-status.enum';
import { Condition } from '../../user-input/models/condition.model';

export class ImageToSave {
    status: ImageUploadStatus;
    progress: number;
    imageNumber: number;
    type: ImageTypes;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    image: any;
    stampCode: string;
    documentScanId: number;
    documentName: string;
    parameterName: string;
    isSaved: boolean;
    extension: string;
    imgAsBase64String: string;
    thumbnailUrl: SafeUrl;
    fileName: string;
    isLoading: boolean;
    hasMismatch: boolean;
    tag: string;
    threshold: number;
    recognitionResult: number;
    isVideo: boolean;
    condition: Condition;
    allowPdf: boolean;
}
